import {reduceByUniqueId, sortByLevelId, sortByIndicatorId} from './utils/assessment-by-employee'
  


  function findLevelByAnswers(levels,answers) {
    return levels 
    ? levels.map(level => {
      const filteredAnswers = answers.filter(answer => answer.levelId === level.id)

      const indicators = level.indicators.map( indicator => {
        const activityIds = filteredAnswers.filter(answer => answer.indicatorId === indicator.id).map(answer => answer.activityId)

        return {
            id: indicator.id,
            text: indicator.text,
            score: indicator.score,
            activityIds
          }
      } ).filter(indicator => indicator.activityIds.length > 0)

      const total = indicators.reduce((acc, indicator) => acc += (indicator.score * 1) ,0)
      const count = indicators.reduce((acc, indicator) => acc += indicator.activityIds.length,0)

      return { id: level.id, name: level.name, total, count , indicators, 
        texts: filteredAnswers.map(answer => ({activityId: answer.activityId, text: answer.text}) )  }
      }) 
    : []
  }
  


  function computeRating(levels) {
    const total = levels.reduce((acc,level) => acc += level.total,0)
    const count = levels.reduce((acc,level) => acc += level.count,0)
  
    return count > 0 ? parseFloat(Math.round(total/count * 100) / 100).toFixed(2) : 0
  }

  function formatRatingLevel(rating) {
    if (rating >= 1 && rating < 2) return 'Novice'
    if (rating >= 2 && rating < 3) return 'Basic'
    if (rating >= 3 && rating < 4) return 'Proficient'
    if (rating >= 4 && rating < 4.5) return 'Advanced'
    if (rating >= 4) return 'Expert'
    return ''
  }


  function findCpByAnswers(cpObj,answers) {
    const cp = cpObj.data
    const levels = findLevelByAnswers(cp.levels,answers)
    const rating = computeRating(levels)
    const ratingLevel = formatRatingLevel(rating) 
    return {
        id: cpObj.id,
        name: cp.name,
        levels,
        rating,
        ratingLevel
    }
  }

  function fetchActivityCps(activities) {
    const promises = activities.reduce((acc,activity) => acc.concat(activity.data.competencies), [])
              .reduce( reduceByUniqueId ,[] )
              .map(cpRef => cpRef.get().then(doc => ( { id: doc.id, data: doc.data() } ) ) )
    return Promise.all(promises)
  }

  export default (assessment) => {

    return fetchActivityCps(assessment.activities).then(cps =>
      cps.map( cp => {
        const sortedAnswers = assessment.answers
          .sort(sortByIndicatorId)
          .sort(sortByLevelId)
        
        return findCpByAnswers(cp,sortedAnswers)
      })
    )  
  }





// WEBPACK FOOTER //
// ./src/assessments/actions-assessment.js